import { Component, OnInit } from '@angular/core';
import {
  FormBuilder,
  Validators,
} from "@angular/forms";
import { ActivatedRoute } from "@angular/router";
import {MatDialog} from '@angular/material/dialog';

import { ApiCallService } from "../../../api/service/api-call.service";
import { ValidationService } from "src/app/services/validation.service";
import { ConfirmComponent } from "src/app/components/dialog/confirm/confirm.component";
import { IConfirmDialogData } from "src/app/components/dialog/dialog.data";
import * as Constants from "../../../constant/Constants";
import { English, Kiswahili } from 'src/app/assets/strings/TZ/localization';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-details',
  templateUrl: './detailsTZ.component.html',
  styleUrls: ['./detailsTZ.component.css']
})
export class DetailsTZComponent implements OnInit {

  // Url Params
  insurance: string = "private"; // private, commercial, special, motorcycle ... etc.
  locale: string = "en";  // en || sw (Language)
  token: string = "placeholder-value"; // to validate the public accesses.
  // +++++++++++

  genericDialogData: IConfirmDialogData = {
    title: '',
    content: '',
    cancelButtonText: '',
    confirmButtonText: ''
  };

  LanguagePack: any = English;

  pageHeading: string = 'Motor Insurance Application';

  formErrors: { [key: string]: string } = {
    fullName: "",
    email: "",
    phone: "",
    // idType: "",
    idNum: "",
  };

  validationMessages: { [key: string]: {[key: string]: string} } = {
    fullName: { required: this.LanguagePack.requiredValidation },
    email: { required: this.LanguagePack.requiredValidation, email: this.LanguagePack.emailValidation },
    phone: { required: this.LanguagePack.requiredValidation },
    // idType: { required: this.LanguagePack.requiredValidation },
    idNum: { required: this.LanguagePack.requiredValidation, minlength: this.LanguagePack.invalidNumValidation, maxlength: this.LanguagePack.invalidNumValidation},
  };

  motorForm = this._formBuilder.group({
    fullName: ["", Validators.required],
    email: ["", [Validators.required, Validators.email]],
    phone: [""],
    // idType: [this.LanguagePack.tinText, Validators.required],
    idNum: ["", Validators.required],
  });

  constructor(
    private _formBuilder: FormBuilder,
    private route: ActivatedRoute,
    public dialog: MatDialog,
    private apiCallService: ApiCallService,
    private validationService: ValidationService,
  ) { }

  loading: boolean = false;
  url: string = environment.baseUrl + Constants.kycTZ_URL;

  selectedIdType: string = '';
  idNumPrefix: string = 'Enter ';
  idNumLabel: string = this.idNumPrefix.concat(this.LanguagePack.tinText);
  minIDNUMLength: number = 8;
  maxIDNUMLength: number = 9;

  ngOnInit(): void {
    this.route.queryParams.subscribe((params) => {
      this.token = params["token"] !== 'undefined' ? params["token"] : Constants.tokenPlaceholderValue;
      
      if (params["locale"] !== undefined) {
        this.locale = params["locale"];
        // Change to Swahili language
        if (params["locale"] === "sw") {
          this.LanguagePack = Kiswahili;
          this.idNumPrefix = "Andika ";
          this.idNumLabel = this.idNumPrefix.concat(this.LanguagePack.tinText);

          this.validationMessages = {
            fullName: { required: this.LanguagePack.requiredValidation },
            email: { required: this.LanguagePack.requiredValidation, email: this.LanguagePack.emailValidation },
            phone: { required: this.LanguagePack.requiredValidation },
            // idType: { required: this.LanguagePack.requiredValidation },
            idNum: { required: this.LanguagePack.requiredValidation, minlength: this.LanguagePack.invalidNumValidation, maxlength: this.LanguagePack.invalidNumValidation},
          };
        }
      }

      if (params["insurance"] !== undefined) {
        this.insurance = params["insurance"];
        this.pageHeading = this.LanguagePack.pagePrivate + this.LanguagePack.continued;

        if (params["insurance"] === "commercial") {
          this.pageHeading = this.LanguagePack.pageCommercial + this.LanguagePack.continued;
          this.url = Constants.quoteCommercialURL;

        } else if (params["insurance"] === "special") {
          this.pageHeading = this.LanguagePack.pageSpecial + this.LanguagePack.continued;
          this.url = Constants.quoteSpecialURL;

        } else if (params["insurance"] === "motorcycle") {
          this.pageHeading = this.LanguagePack.pageMotorcycle + this.LanguagePack.continued;
          this.url = Constants.quoteMotorcycleURL;
        }
      }
    });

    this.motorForm.valueChanges.subscribe((form) => {
      this.logErrors();

      if (form.fullName) {
        this.motorForm.patchValue({
          fullName: form.fullName.replace(/[a-z]/g, (match) => match.toUpperCase())
        }, {emitEvent: false});
      }
      if (form.phone) {
        this.motorForm.patchValue({
          phone: form.phone.replace(/\D/g, '')
        }, {emitEvent: false});
      }
      if (form.idNum) {
        this.motorForm.patchValue({
          idNum: form.idNum.replace(/[a-z]/g, (match) => match.toUpperCase())
        }, {emitEvent: false});
      }
    });
  }

  // Switches IDNum label text + input based on ID Type control
  // updateID() {
  //   // this.selectedIdType = this.motorForm.controls['idType'].value;
  //     this.idNumLabel = this.idNumPrefix.concat(this.LanguagePack.tinText);
      
  //   //   if (this.motorForm.controls['idType'].value !== null) {
      
      
  //   //   // unused for now
  //   //   // if (this.selectedIdType === 'NATIONAL IDENTIFICATION NUMBER (NIN)' 
  //   //   //   || this.selectedIdType === 'NAMBA YA KITAMBULISHO CHA TAIFA (NIN)' ) {
  //   //   //   this.minIDNUMLength = 12;
  //   //   //   this.maxIDNUMLength = 25;
  //   //   // } else if (this.selectedIdType === 'TAXPAYER IDENTIFICATION NUMBER (TIN)'
  //   //   // || this.selectedIdType === '') {
  //   //   //   this.minIDNUMLength = 8;
  //   //   //   this.maxIDNUMLength = 9;
  //   //   // } else if (this.selectedIdType === 'VOTERS REGISTRATION NUMBER'
  //   //   //   || this.selectedIdType === 'NAMBA YA KUJIANDIKISHA KUPIGA KURA') {
  //   //   //   this.minIDNUMLength = 8;
  //   //   //   this.maxIDNUMLength = 11;
  //   //   // } else if (this.selectedIdType === 'PASSPORT NUMBER'
  //   //   //   || this.selectedIdType === 'NAMBA YA PASIPOTI') {
  //   //   //   this.minIDNUMLength = 7;
  //   //   //   this.maxIDNUMLength = 10;
  //   //   // } else if (this.selectedIdType === 'DRIVING LICENSE'
  //   //   //   || this.selectedIdType === 'LESENI YA KUENDESHA GARI') {
  //   //   //   this.minIDNUMLength = 9;
  //   //   //   this.maxIDNUMLength = 10;
  //   //   // }
      
  //   //   this.validationService.addOrRemoveIDumValidator(true, this.motorForm.get('idNum')!, this.minIDNUMLength, this.maxIDNUMLength)
  //   // }
  // };

  logErrors() {
    this.formErrors = this.validationService.logValidationErrors(
      this.motorForm,
      this.formErrors,
      this.validationMessages
    );
  }

  showGenericPopup(runFunction: ()=> void) {
    const dialogRef = this.dialog.open(ConfirmComponent, {
      disableClose: true,
      data: this.genericDialogData,
    });

    dialogRef.afterClosed().subscribe(result => {
      console.group('Generic Dialog');
      if (result) {
        console.log('dialog confirmed');
        runFunction();
      } else {
        console.log('dialog dismissed');
      }
      console.groupEnd();
    });
  };

  initDialogData(title: string, content: string, cancelButtonText: string, confirmButtonText: string) {
    this.genericDialogData.title = title;
    this.genericDialogData.content = content;
    this.genericDialogData.cancelButtonText = cancelButtonText;
    this.genericDialogData.confirmButtonText = confirmButtonText;
  };

  postDataToWhatsapp = async () => {
    this.loading = true;

    const req = {
      class: this.insurance,
      fullName: this.motorForm.controls["fullName"].value,
      email: this.motorForm.controls["email"].value,
      phone: this.motorForm.controls["phone"].value,
      // idType: this.motorForm.controls["idType"].value,
      idNum: this.motorForm.controls["idNum"].value,

      token: this.token,
      filled: true,
    };

    try {
      const response = await this.apiCallService.postRequest(`${this.url}?token=${this.token}`, req);

      console.log(":: Response data ::  ", response);

      if (response.error === false) {
        console.log("::: Post successful :::");
        // Auto-close the breakout page
        window.close();
      } else {
        console.log("::: Post failed :::", response.message);
        this.loading = false;

        this.initDialogData(
          this.LanguagePack.submissionFailed,
          this.LanguagePack.savingError,
          this.LanguagePack.cancel,
          this.LanguagePack.tryAgain
        );

        this.showGenericPopup(this.postDataToWhatsapp);
      }
    } catch (error) {
      console.log('ERROR :: ', error);
      this.loading = false;

      this.initDialogData(
        this.LanguagePack.submissionFailed,
        this.LanguagePack.unexpectedError,
        this.LanguagePack.cancel,
        this.LanguagePack.tryAgain
      );
      this.showGenericPopup(this.postDataToWhatsapp);
    }
    
  }

  submitForm(): void {
    this.initDialogData(
      this.LanguagePack.confirmSubmission,
      this.LanguagePack.proceedDesc,
      this.LanguagePack.back,
      this.LanguagePack.proceed
    );

    this.showGenericPopup(this.postDataToWhatsapp);
  }

  confirmCancel() {
    this.initDialogData(
      this.LanguagePack.warning,
      this.LanguagePack.confirmCancel,
      this.LanguagePack.backSmallCaps,
      this.LanguagePack.cancelApplication
    );

    this.showGenericPopup(this.cancelApplication);
  }
  
  cancelApplication = async () =>  {
    console.log("Cancelling application ...");
    // Update session that form application was cancelled
    this.loading = true;

    const req = {
      // User cancelled
      token: this.token,
      filled: false,
    };

    try {
      const response = await this.apiCallService.postRequest(`${this.url}?token=${this.token}`, req);

      console.log(":: Response data ::  ", response);

      if (response.error === false) {
        console.log("::: Cancel Post successful :::");
        // Auto-close the breakout page
        window.close();

      } else {
        console.log("::: Cancel Post failed :::", response.message);
        this.loading = false;

        this.initDialogData(
          this.LanguagePack.submissionFailed,
          this.LanguagePack.savingError,
          this.LanguagePack.cancel,
          this.LanguagePack.tryAgain
        );

        this.showGenericPopup(this.cancelApplication);
      }
    } catch (error) {
      console.log('ERROR :: ', error);
      this.loading = false;

      // Auto-close the breakout page
      window.close();
    }
  }

}
